import generateActions from './baseAction';
import API from '../api';
import { REQUEST_UPDATE_SETTINGS, RECEIVE_UPDATE_SETTINGS } from '../constants';

const { getSettings } = generateActions('setting', 'settings');

const updateSettings = (settings) => async (dispatch) => {
  dispatch({
    settings,
    type: REQUEST_UPDATE_SETTINGS,
  });
  const response = await API.request('/settings', 'POST', {
    settings: JSON.stringify(settings),
  });
  const { error, data } = await response.json();
  dispatch({
    error,
    data,
    type: RECEIVE_UPDATE_SETTINGS,
  });
  return data;
};

export { getSettings, updateSettings };
